import { render, staticRenderFns } from "./PreviewFeatures.vue?vue&type=template&id=160d4008&"
import script from "./PreviewFeatures.vue?vue&type=script&lang=js&"
export * from "./PreviewFeatures.vue?vue&type=script&lang=js&"
import style0 from "./PreviewFeatures.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports